import { z } from 'zod'
import { PublicDocumentPolicySchema } from '../domain/document-policy'
import { route } from '../route-def'

/**
 * What the member pages need to fill the copy placeholders (`<Org>`, `<contact>`, `<phone>`), the controller name of
 * /privacy and the map settings of the admin pages, and (identity-document spec §4.1) whether the document step is
 * required, with the step count that follows from it. Nothing here is secret.
 */
export const PublicConfigSchema = z.object({
  org: z.object({
    name: z.string(),
    contact: z.string(),
    phone: z.string(),
    controllerName: z.string(),
  }),
  mapTileUrl: z.string(),
  mapAttribution: z.string(),
  document: PublicDocumentPolicySchema,
  /** Days the photos kept for a review are held at most (consent texts: "at the latest after {{days}} days"). */
  reviewMediaHoldDays: z.number().int().min(1),
})
export type PublicConfig = z.infer<typeof PublicConfigSchema>

export const publicRoutes = {
  publicConfig: route({
    method: 'GET',
    path: '/api/public/config',
    auth: 'public',
    response: PublicConfigSchema,
  }),
}
